import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { orderDetailsButtonSetStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsButtonSet";

orderDetailsButtonSetStyles.shareEntityButtonStyles = mergeToNew(orderDetailsButtonSetStyles.shareEntityButtonStyles, {
    button: {
        variant: "secondary",
        color: "common.accent",
    },
});
